module.exports = __webpack_public_path__ + "img/poly-4.66c58360.png";